import { z } from '@hono/zod-openapi'
import { benefitImagesTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export const zSelectBenefitImage = createSelectSchema(benefitImagesTable)
export const zInsertBenefitImage = createInsertSchema(benefitImagesTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateBenefitImage = zInsertBenefitImage.partial()
export const zQueryBenefitImages = zInsertBenefitImage
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()

export type SelectBenefitImage = z.infer<typeof zSelectBenefitImage>
export type InsertBenefitImage = z.infer<typeof zInsertBenefitImage>
export type UpdateBenefitImage = z.infer<typeof zUpdateBenefitImage>
export type QueryBenefitImages = z.infer<typeof zQueryBenefitImages>
export type ColumnsOfBenefitImagesTable =
    keyof typeof benefitImagesTable._.columns
